<template>
	<div class="pb-30">
		<md-card class="mt-20">
			<md-card-header class="ask-subject" :style="communityStyle" v-text="$lodash.has(community, 'name') ? community.name + ': ' + ask.subject : ask.subject">
			</md-card-header>
		</md-card>
		<ask-detail class="mt-30" :ask="ask" v-on:chosen="addSeeker" editAsk="true">Ask detail goes here...</ask-detail>
		<md-card class="mt-30">
			<md-card-header>
				<div class="md-title card-header">What insight did this advisor give:</div>
			</md-card-header>
			<md-card-content>
				<md-field class="textareaAfter">
					<md-textarea v-model="insight" @input="insight = sanitizeInput($event)" placeholder="..."></md-textarea>
				</md-field>
				<md-card>
					<md-card-header>
						Who gave this insight?
					</md-card-header>
					<md-card-content>
						<multi-member-picker v-if="advisors.length >0" v-on:changed="updateSelected" :members="advisors" :selected="selectedAdvisors">Advisors goes here...</multi-member-picker>
					</md-card-content>
				</md-card><br />
				<md-ripple>
					<base-interaction-button :interaction="action" @interact="doInteraction">{{ action }}</base-interaction-button>
				</md-ripple>
			</md-card-content>
		</md-card>
		<ask-feedback class="mt-30" :ask="ask">Feedback goes here...</ask-feedback>
		<comments class="mt-30" :ask="ask" section="Comments">Activity log goes here...</comments>
		<activity-log class="mt-30" :ask="ask">Activity log goes here...</activity-log>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import AskDetail from "./AskDetail";
import ActivityLog from "./ActivityLog";
import MultiMemberPicker from "./MultiMemberPicker";
import Comments from "./Comments";
import AskFeedback from "./AskFeedback";
import { sanitizeInput } from '@/utils/sanitizer';

export default {
  components: {
    ActivityLog,
    AskDetail,
    MultiMemberPicker,
    Comments,
    AskFeedback
  },
  data() {
    return {
      api: new API(),
      ask: {},
      action: "respond",
      insight: "",
      createdByMember: {},
      advisors: [],
      selectedAdvisors: [],
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      },
      community: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    sanitizeInput(event) {
      return sanitizeInput(event);
    },
    loadData: async function() {
      await this.api.get(`asks/${this.$route.params.ask_id}`).then(async ask => {
        this.ask = ask.data;
        if (this.ask) {
          if (this.ask.activityLog) {
            this.ask.activityLog.sort((a, b) => {
              return a.when > b.when ? -1 : 1;
            });
          }
          this.ask.recommendedAdvisors.map(async id => {
            await this.api.get(`members/${id}`).then(member => {
              this.advisors.push(member.data);
            });
          });
          this.createdByMember = this.ask.createdByMemberID;
          // this.api.get(`members/${this.ask.createdByMemberID}`).then(member => {
          //   this.createdByMember = member.data;
          // });
          // this.api.get(`communities/${this.ask.community}`).then(community => {
	      	  this.community = this.ask.community;
	          if (this.$lodash.has(this.community, 'customSettings')) {
	          	this.communityStyle.backgroundColor = this.community.customSettings.primaryColor;
	          	this.communityStyle.color = this.community.customSettings.secondaryColor;
	          }
	      // });
        }
      });
    },
    updateSelected: function(selectedList) {
      this.selectedAdvisors = selectedList;
    },
    doInteraction: async function() {
      await this.api
        .post(`asks/${this.ask._id}/${this.action}`, {
          advisors: this.selectedAdvisors,
          insight: this.insight
        })
        .then(response => {
          this.$emit("reload");
          this.$router.push(`/`);
        });
    },
    getCreatedBy: function() {
      this.createdByMember = this.ask.createdByMemberID;
      // this.api.get(`members/${this.ask.createdByMemberID}`).then(member => {
      //   this.createdByMember = member.data;
      // });
    },
    addSeeker: function(members) {
    	this.ask.createdByMemberID = members[0];
    	this.getCreatedBy();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InteractAddGive.vue